import Vue from "vue";
import BaseService from "./base";

const SearchService = {

    base: BaseService.base,
    sortMap: {
        date: 'date_made',
        title: 'title',
        person: 'artist_maker',
        number: 'artifact_num'
    },

    /**
     * Basic search: one term and all fields
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} query
     * @param {*} sort
     * @param {*} order
     * @param {*} page
     * @param {*} size
     * @param {*} type
     */
    search(lang, query, sort, order, page=1, size=24, type, output='small') {
        var endpoint = `${this.base()}/_search/`;
        if (type == 'all' && sort != 'title') {
            sort = 'title'
        } else {
            sort = this.sortMap[sort];
        }


        return Vue.axios.post(endpoint,
            {
                lang: lang,
                site: "collections",
                type: type,
                terms: query,
                sort: sort,
                order: order,
                page: page,
                size: size,
                output: output
            }
            ).catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },

    /**
     * Search suggestions: Returns 3 suggested search terms
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} query
     */
     suggestions(lang, query) {
        // var endpoint = `${this.base()}/_search/`;
        var endpoint = `https://beta.historymuseum.ca/_api/_search/_field/values/${lang}/collections/all/title/${query}/?size=3`
        // console.log(endpoint);

        return Vue.axios.get(endpoint)
            .catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },

    /**
     * Populate dropdown filters in advanced search
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} type The item type, either 'artifact' or 'archive'
     * @param {*} field The field name
     */
    refinementOptions(lang, type, field) {
        var endpoint = `${this.base()}/_search/_field/values/?lang=${lang}&site=collections&type=${type}&field=${field}`;

        return Vue.axios.get(endpoint).catch(error => {
            throw new Error(`ApiService::list ${error}`);
        });
    },
    
    /**
     * Get a count of artifacts that satisfy a query
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} query
     * @param {*} sort
     * @param {*} order
     * @param {*} page
     * @param {*} size
     */
     count(lang, query, sort, order, page=1, size=30) {
        //  TODO use count api endpoint
        var endpoint = `${this.base()}/_search/`;
        if (sort == 'call_nums') {
            sort = 'number'
        }

        return Vue.axios.post(endpoint,
            {
                lang: lang,
                site: "collections",
                type: "all",
                terms: query,
                sort: this.sortMap[sort],
                order: order,
                page: page,
                size: size,
                output: 'min'
            }
            ).catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },

     /**
     * Get items by ids
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} query
     * @param {*} sort
     * @param {*} order
     * @param {*} page
     * @param {*} size
     * @param {*} type
     */
      get_ids(lang, query, sort, order, page=1, size=100, type, output='small') {
        var endpoint = `${this.base()}/_list/_ids`;

        return Vue.axios.post(endpoint,
            {
                lang: lang,
                site: "collections",
                doc_type: type,
                ids: query,
                sort: sort,
                order: order,
                page: page,
                size: size,
                output: output
            }
            ).catch(error => {
                throw new Error(`ApiService:: get by ids list ${error}`);
            });
    },


};

export default SearchService;
